import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { BackupService } from '../../core/backup';
import { StagingService } from '../../core/staging';
import { SharedModule } from '../../shared/shared.module';
import { AppDialogModule } from '../dialog';
import { StagingFromBackupModalComponent } from './staging-from-backup-modal/staging-from-backup-modal.component';
import { StagingFromBackupTableComponent } from './staging-from-backup-table/staging-from-backup-table.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    AppDialogModule,
    MatTabsModule,
    SharedModule,
    MatDialogModule,
    MatTooltipModule,
  ],
  declarations: [StagingFromBackupTableComponent, StagingFromBackupModalComponent],
  exports: [StagingFromBackupModalComponent],
  providers: [BackupService, StagingService],
})
export class StagingFromBackupModule {}
